import { useEffect, useState } from 'react';
import { Tooltip } from '@mui/material';
import { Device } from 'types';
import {
    GenericStatusIcon,
    statusClassState,
} from '../GenericStatusIcon/GenericStatusIcon';
import { isLastReadingTimeOffline } from 'helpers/device-offline';

export function LastReadingTimeIcon(props: Device) {
    const tooltip = 'Last Reading Time';
    const [status, setStatus] = useState<statusClassState>(null);

    useEffect(() => {
        if (!props.lastReading) {
            setStatus('alert');
            return;
        }

        if (
            isLastReadingTimeOffline(
                props.lastReading.time,
                props.r_int,
                props.t_int
            )
        ) {
            setStatus('alert');
        } else setStatus('success');
    }, [props]);

    return (
        <div data-testid="LastReadingTimeIcon">
            <Tooltip data-testid="Tooltip" title={tooltip}>
                <GenericStatusIcon status={status} />
            </Tooltip>
        </div>
    );
}
